import fileSys from "../../fileoprators/fileSystem";
import SettingsOprator from "../../settings/settingsoprator";
import { DATASHAPSONMAP, NORMALMAPSTYLES, forgeDeepCopy, PAGES } from "../shared/index";
const DEFAULT = {
  [DATASHAPSONMAP[0]]: false,
  [DATASHAPSONMAP[1]]: false,
  [DATASHAPSONMAP[2]]: false,
  [DATASHAPSONMAP[3]]: false,
  [DATASHAPSONMAP[4]]: false,
  [DATASHAPSONMAP[5]]: false,
  [DATASHAPSONMAP[6]]: false,
  [DATASHAPSONMAP[7]]: true,
  [DATASHAPSONMAP[8]]: false,
  [DATASHAPSONMAP[9]]: false,
  [DATASHAPSONMAP[10]]: false,
  [DATASHAPSONMAP[11]]: false
};
class MapDrawConfig extends SettingsOprator {
  constructor() {
    super();
    this.init(fileSys.getTopographyCfgPath("mapDrawSettings.json"), this.getDefaultSettings());
    this.mapDrawSettings = this.getSettings();
  }
  getDefaultSettings() {
    let defaultSettings = {};
    for (let p in PAGES) {
      if (PAGES[p].mapSettings) {
        let page = PAGES[p].key;
        defaultSettings[page] = {};
        for (let i = 0; i < PAGES[p].mapCount; i++) {
          let indexes = [1, 3, 5, 9];
          defaultSettings[page][`mapInForm${i}`] = { mapIndexUI: indexes[i] };
          for (let id in NORMALMAPSTYLES) {
            defaultSettings[page][`mapInForm${i}`]["shapes"] = forgeDeepCopy(DEFAULT);
          }
        }
      }
    }
    defaultSettings["zernike"][`mapInForm0`] = { mapIndexUI: 5 };
    return defaultSettings;
  }
}
let mapDrawConfig = new MapDrawConfig();
export let { mapDrawSettings } = mapDrawConfig;
export default mapDrawConfig;



// WEBPACK FOOTER //
// ./src/topography/config/map-draw.js